/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_AfterInputs */

const en_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All After`)
};

const fr_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner tout après`)
};

const de_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle auswählen nach`)
};

const it_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutto dopo`)
};

const ru_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все после`)
};

const es_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo después`)
};

const zh_cn2_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择所有`)
};

const ja_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選択後`)
};

const hi_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी का चयन करें`)
};

const pt_pt2_context_menu_select_all_after = /** @type {(inputs: Context_Menu_Select_All_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar tudo depois`)
};

/**
* | output |
* | --- |
* | "Select All After" |
*
* @param {Context_Menu_Select_All_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_after = /** @type {((inputs?: Context_Menu_Select_All_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_select_all_after(inputs)
	if (locale === "de") return de_context_menu_select_all_after(inputs)
	if (locale === "it") return it_context_menu_select_all_after(inputs)
	if (locale === "ru") return ru_context_menu_select_all_after(inputs)
	if (locale === "es") return es_context_menu_select_all_after(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_select_all_after(inputs)
	if (locale === "ja") return ja_context_menu_select_all_after(inputs)
	if (locale === "hi") return hi_context_menu_select_all_after(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_select_all_after(inputs)
	return en_context_menu_select_all_after(inputs)
});